// eslint-disable-next-line import/prefer-default-export
export const MAX_EMAIL_ADDRESS_ON_CARD = 5;

export const EMAIL_STATUS = {
  REVOKED: 'REVOKED',
  CONNECTED: 'CONNECTED',
};

export const REVOKE_EMAIL_WARNING =
  'Access to your Email inbox has been revoked. Emails won’t sync until you reconnect your inbox in the Integrations page.';

export const NO_OUTLOOK_CONFIG_EMAIL_WARNING =
  'Outlook not configured. Please contact your administrator';

export const NO_EMAIL_CONFIG_EMAIL_WARNING =
  'Gmail not configured. Please contact your administrator';

export const EMAIL_CONNECTING_RETRY_WARNING =
  'Sign In failed, please retry connecting your inbox';

export const EMAIL_HIDE_STATUS = {
  ACTIVE: 0,
  HIDDEN: 10,
};

export const MIN_PARTICIPANTS_FOR_REPLY_ALL = 2;
export const MIN_PARTICIPANTS_FOR_TO = 1;
export const FROM_PARTICIPANTS_LENGTH = 1;

export const DATE_OPTIONS_TO_DAYS_MAPPING = {
  today: 0,
  tommorow: 1,
  inthreedays: 3,
};
